import adjustQuantityModel from './adjustQuantityModel/adjustQuantityModel.vue'
import arAccountModel from './arAccountModel/arAccountModel.vue'
import assistSizeModel from './assistSizeModel/assistSizeModel.vue'
import bankPosModel from './bankPosModel/bankPosModel.vue'
import batchGiveModel from './batchGiveModel/batchGiveModel.vue'
import batchReturnModel from './batchReturnModel/batchReturnModel.vue'
import batchUpdateNumModel from './batchUpdateNumModel/batchUpdateNumModel.vue'
import changeNumPriceModel from './changeNumPriceModel/changeNumPriceModel.vue'
import changeSetMealModel from './changeSetMealModel/changeSetMealModel.vue'
import changeUnitModel from './changeUnitModel/changeUnitModel.vue'
import comboFoodModel from './comboFoodModel/comboFoodModel.vue'
import copyFoodModel from './copyFoodModel/copyFoodModel.vue'
import customDishesModel from './customDishesModel/customDishesModel.vue'
import demandFullModel from './demandFullModel/demandFullModel.vue'
import demandModel from './demandModel/demandModel.vue'
import discountModel from './discountModel/discountModel.vue'
import discountReadCardModel from './discountReadCardModel/discountReadCardModel.vue'
import editOrderOperatorModel from './editOrderOperatorModel/editOrderOperatorModel.vue'
import enterBindingModel from './enterBindingModel/enterBindingModel.vue'
import giveReturnModel from './giveReturnModel/giveReturnModel.vue'
import kitchenModel from './kitchenModel/kitchenModel.vue'
import kitOrderPrintModel from './kitOrderPrintModel/kitOrderPrintModel.vue'
import KitPrintMonitorModel from './KitPrintMonitorModel/KitPrintMonitorModel.vue'
import lockersModel from './lockersModel/lockersModel.vue'
import makeupTCModel from './makeupTCModel/makeupTCModel.vue'
import memberCardPriceModel from './memberCardPriceModel/memberCardPriceModel.vue'
import numModifyModel from './numModifyModel/numModifyModel.vue'
import promotionalSelectModel from './promotionalOffer/promotionalSelectModel/promotionalSelectModel.vue'
import promotionalGiveModel from './promotionalOffer/promotionalGiveModel/promotionalGiveModel.vue'
import readyToUsePackageModel from './readyToUsePackageModel/readyToUsePackageModel.vue'
import serviceFeeModel from './serviceFeeModel/serviceFeeModel.vue'
import setDekNumModel from './setDekNumModel/setDekNumModel.vue'
import setMealModel from './setMealModel/setMealModel.vue'
import ShrinkView from './ShrinkView/ShrinkView.vue'
import subItemModel from './subItemModel/subItemModel.vue'
import transferFoodModel from './transferFoodModel/transferFoodModel.vue'
import unionOrderDishModel from './unionOrderDishModel/unionOrderDishModel.vue'
import urgeFoodModel from './urgeFoodModel/urgeFoodModel.vue'
import WholeRetreatModel from './WholeRetreatModel/WholeRetreatModel.vue'
import withMenuModel from './withMenuModel/withMenuModel.vue'

import cardCodeModel from './model/cardCodeModel.vue'
import passwordConfirmModel from './model/passwordConfirmModel.vue'
import swipeCardModel from './model/swipeCardModel.vue'



import cardAbuttingModel from './cardAbuttingModel/cardAbuttingModel.vue'
import daNianPayModel from './daNianPayModel/daNianPayModel.vue'
import enterCloseModel from './enterCloseModel/enterCloseModel.vue'
import freeShippingModel from './freeShippingModel/freeShippingModel.vue'
import gNinePaymentModel from './gNinePaymentModel/gNinePaymentModel.vue'
import keMaMemberPayModel from './keMaMemberPayModel/keMaMemberPayModel.vue'
import kunLunMemberPayModel from './kunLunMemberPayModel/kunLunMemberPayModel.vue'
import memberPaymentModel from './memberPaymentModel/memberPaymentModel.vue'
import newEnjoyShowModel from './newEnjoyShowModel/newEnjoyShowModel.vue'
import paymentCouponsModel from './paymentCouponsModel/paymentCouponsModel.vue'
import payRemarkModel from './payRemarkModel/payRemarkModel.vue'
import popupInputModel from './popupInputModel/popupInputModel.vue'
import preMoneyModel from './preMoneyModel/preMoneyModel.vue'
import saveCouponsModel from './saveCouponsModel/saveCouponsModel.vue'
import saveCouponsPayModel from './saveCouponsPayModel/saveCouponsPayModel.vue'
import scanCodePayModel from './scanCodePayModel/scanCodePayModel.vue'
import westSoftAccountModel from './westSoftAccountModel/westSoftAccountModel.vue'
import westSoftCouponspayModel from './westSoftCouponspayModel/westSoftCouponspayModel.vue'
import westStoredModel from './westStoredModel/westStoredModel.vue'
import wliveMemberPaymentModel from './wliveMemberPaymentModel/wliveMemberPaymentModel.vue'
import yinShiScanCodePayModel from './yinShiScanCodePayModel/yinShiScanCodePayModel.vue'
import yinShiYuFuCardPayModel from './yinShiYuFuCardPayModel/yinShiYuFuCardPayModel.vue'
import zpCouponspayModel from './zpCouponspayModel/zpCouponspayModel.vue'



export {
    /**数量调整 */
    adjustQuantityModel,
    /**AR挂账功能 */
    arAccountModel,
    /**数量确认 */
    assistSizeModel,
    /**BankPos操作 */
    bankPosModel,
    /**批量赠送 */
    batchGiveModel,
    /**批量退菜 */
    batchReturnModel,
    /**批量改量 */
    batchUpdateNumModel,
    /**改价操作 或 改量操作 */
    changeNumPriceModel,
    /**套餐 换菜 */
    changeSetMealModel,
    /**菜品换单位 */
    changeUnitModel,
    /**组合菜品 */
    comboFoodModel,
    /**复制其它桌台菜品 */
    copyFoodModel,
    /**自定义菜品 */
    customDishesModel,
    /**全单要求操作 */
    demandFullModel,
    /**菜品要求操作 */
    demandModel,
    /**折扣操作 */
    discountModel,
    /**会员全单折扣 */
    discountReadCardModel,
    /**修改点菜员 */
    editOrderOperatorModel,
    /**企业团餐绑定 */
    enterBindingModel,
    /**退菜操作 或 赠送操作 */
    giveReturnModel,
    /**厨房操作 */
    kitchenModel,
    /**补打厨房单 */
    kitOrderPrintModel,
    /**打印监控服务 提示 待打印任务*/
    KitPrintMonitorModel,
    /**提取暂存 */
    lockersModel,
    /**单品组合套餐 */
    makeupTCModel,
    /**订单 优惠活动选择 */
    promotionalSelectModel,
    /**订单 满赠活动 赠送菜品选择 */
    promotionalGiveModel,
    /**即配套餐 或 即配套餐换菜 */
    readyToUsePackageModel,
    /**服务费操作 */
    serviceFeeModel,
    /**修改席数 */
    setDekNumModel,
    /**套餐 */
    setMealModel,
    /**滑动展开组件 */
    ShrinkView,
    /**更多功能 */
    subItemModel,
    /**转菜操作 */
    transferFoodModel,
    /**联台下单 */
    unionOrderDishModel,
    /**催菜操作 */
    urgeFoodModel,
    /**整桌退菜 */
    WholeRetreatModel,
    withMenuModel,

    /**会员支付中  券的数量确认 */
    numModifyModel,
    /**订单 执行会员价 */
    memberCardPriceModel,
    /**短信验证 */
    cardCodeModel,
    /**密码验证 */
    passwordConfirmModel,
    /** 会员刷卡 */
    swipeCardModel,

    /**海鼎卡支付 */
    cardAbuttingModel,
    /**大拈会员支付 */
    daNianPayModel,
    /** 企业结算*/
    enterCloseModel,
    /**免单信息确认 */
    freeShippingModel,
    /**G9会员卡支付 */
    gNinePaymentModel,
    /**科码会员支付 */
    keMaMemberPayModel,
    /**昆仑会员支付 */
    kunLunMemberPayModel,
    /**会员支付 */
    memberPaymentModel,
    /**type 1 新享会支付 或 2二维火券支付 */
    newEnjoyShowModel,
    /**现金券 或 商品券 选择 */
    paymentCouponsModel,
    /**付款结算备注 */
    payRemarkModel,
    /**支付中 修改  应付金额 */
    popupInputModel,
    /**押金支付 */
    preMoneyModel,
    /**卡券核销 */
    saveCouponsModel,
    /**卡券支付 */
    saveCouponsPayModel,
    /**聚合支付 扫码付 */
    scanCodePayModel,
    /**西软挂账接口功能 */
    westSoftAccountModel,
    /**西软卡券核销 */
    westSoftCouponspayModel,
    /**西软XMS储值支付 */
    westStoredModel,
    /**微生活支付 */
    wliveMemberPaymentModel,
    /**智能POS支付 */
    yinShiScanCodePayModel,
    /**银石预付卡支付 */
    yinShiYuFuCardPayModel,
    /**正品卡券核销 */
    zpCouponspayModel,
}